import { graphqlBaseOperation } from "@redux/utils/graphqlBaseOperation";
import { createApi } from "@reduxjs/toolkit/query/react";
import { Tags } from "@redux/types";

/**
 * Create a base API to inject endpoints into elsewhere.
 * Components using this API should import from the injected site,
 * in order to get the appropriate types,
 * and to ensure that the file injecting the endpoints is loaded
 */
export const api = createApi({
  /**
   * A bare bones base query would just be `baseQuery: fetchBaseQuery({ baseUrl: '/' })`
   */
  baseQuery: graphqlBaseOperation(),
  /**
   * Tag types must be defined in the original API definition
   * for any tags that would be provided by injected endpoints
   */
  tagTypes: [
    Tags.Community,
    Tags.Portfolio,
    Tags.Resident,
    Tags.ResidentsSearch,
    Tags.Review,
    Tags.Coverage,
  ],
  /**
   * This api has endpoints injected in adjacent files,
   * which is why no endpoints are shown below.
   */
  endpoints: () => ({}),
});
